import compose from 'utils/composeEnhancer'
import useReCaptcha from 'hooks/useReCaptcha'

import useCmsData from './useCmsData'
import useGlobalTrackings from './useGlobalTrackings'

export default compose(useReCaptcha, useCmsData, useGlobalTrackings)
